import React from 'react';
import PropTypes from 'prop-types';
import Message, {getMessage} from '../common/Message';
import getInfluencersFlowSchema from '../../data/InfluencersFlowSchema';
import Select from 'epic-diesel-form/src/components/form/Select';
import Input from 'epic-diesel-form/src/components/form/Input';
import styles from './Bank.pcss';

export default class Bank extends React.Component {
    static propTypes = {
        messages: PropTypes.object.isRequired,
        form: PropTypes.object,
        trigger: PropTypes.func,
        disabled: PropTypes.bool
    };

    onChange = event => {
        const {name, value} = event.target;
        this.props.trigger(name, value);
    };

    render() {
        const {messages, form, trigger, disabled} = this.props;
        const options = [
            {value: false, label: getMessage(messages, 'epic.affiliate.settings.bank_us')},
            {value: true, label: getMessage(messages, 'epic.affiliate.settings.bank_non_us')}
        ];
        const isForeign = form.foreignBank === true || form.foreignBank === 'true';
        const payoutInfoSchema = getInfluencersFlowSchema(getMessage, messages).payoutInfo;
        const bankInformation = (
            <div>
                <p>{payoutInfoSchema.routingNo.display.toolTip}</p>
                <div className="bank-info-image" />
            </div>
        );
        return (
            <div className={styles.section}>
                <div className={styles.title}>
                    <Message code="epic.affiliate.settings.bank_title" />
                </div>
                <div className={styles.row}>
                    <div>
                        <Select
                            required
                            name={payoutInfoSchema.foreignBank.identifier}
                            value={form.foreignBank}
                            options={options}
                            onChange={trigger}
                            disabled={disabled}
                        />
                    </div>
                    <div>
                        <Input
                            name={payoutInfoSchema.checkName.identifier}
                            value={form.checkName || ''}
                            placeholder={payoutInfoSchema.checkName.display.text}
                            validations={payoutInfoSchema.checkName.validations}
                            validationErrors={payoutInfoSchema.checkName.validationMessages}
                            disabled={disabled}
                            onChange={this.onChange}
                            required
                        />
                    </div>
                </div>
                <div className={styles.row}>
                    <div>
                        <Input
                            name={payoutInfoSchema.bankName.identifier}
                            value={form.bankName || ''}
                            text={payoutInfoSchema.bankName.display.text}
                            placeholder={payoutInfoSchema.bankName.display.text}
                            validations={payoutInfoSchema.bankName.validations}
                            validationErrors={payoutInfoSchema.bankName.validationMessages}
                            disabled={disabled}
                            onChange={this.onChange}
                            required
                        />
                    </div>
                    <div>
                        <Input
                            id={payoutInfoSchema.routingNo.identifier}
                            name={payoutInfoSchema.routingNo.identifier}
                            type="text"
                            value={form.routingNo || ''}
                            text={payoutInfoSchema.routingNo.display.text}
                            fieldRequirement={isForeign ? 'require' : 'optional'}
                            placeholder={payoutInfoSchema.routingNo.display.text}
                            validations={payoutInfoSchema.routingNo.validations}
                            validationErrors={payoutInfoSchema.routingNo.validationMessages}
                            tooltipMsg={bankInformation}
                            disabled={disabled}
                            onChange={this.onChange}
                            required={!isForeign}
                            addonAfter="?"
                        />
                    </div>
                </div>
                <div className={styles.row}>
                    <div className={isForeign ? styles.isForeign : ''}>
                        <Input
                            id={payoutInfoSchema.bankAccountNo.identifier}
                            name={payoutInfoSchema.bankAccountNo.identifier}
                            type="text"
                            value={form.bankAccountNo || ''}
                            text={
                                !isForeign
                                    ? payoutInfoSchema.bankAccountNo.display.textBankAccountNo
                                    : payoutInfoSchema.bankAccountNo.display.textIBAN
                            }
                            placeholder={
                                !isForeign
                                    ? payoutInfoSchema.bankAccountNo.display.textBankAccountNo
                                    : payoutInfoSchema.bankAccountNo.display.textIBAN
                            }
                            validations={disabled ? {} : payoutInfoSchema.bankAccountNo.validations}
                            validationErrors={payoutInfoSchema.bankAccountNo.validationMessages}
                            tooltipMsg={bankInformation}
                            addonAfter="?"
                            onChange={this.onChange}
                            disabled={disabled}
                            required
                        />
                    </div>
                    {isForeign && (
                        <div>
                            <Input
                                name={payoutInfoSchema.swiftCode.identifier}
                                value={form.swiftCode || ''}
                                text={payoutInfoSchema.swiftCode.display.text}
                                placeholder={payoutInfoSchema.swiftCode.display.text}
                                validations={payoutInfoSchema.swiftCode.validations}
                                validationErrors={payoutInfoSchema.swiftCode.validationMessages}
                                disabled={disabled}
                                onChange={this.onChange}
                                required={isForeign}
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
